import { apiTypes } from '~/const/api';

export const getCssClassFromType = (type: string) => {
  switch (type) {
    case apiTypes.TEXT:
      return 'text';
    case apiTypes.RADIO:
      return 'radio';
    case apiTypes.CONDITIONAL:
      return 'radio';
    case apiTypes.CHECK:
      return 'check';
    case apiTypes.STAR_RATING:
      return 'star-rating';
    default:
      return undefined;
  }
};

export const hasChoicesType = (type: string) => {
  return (
    type === apiTypes.CHECK
    || type === apiTypes.RADIO
    || type === apiTypes.CONDITIONAL
  );
};
